export const DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;
export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const CVV_REGEX = /^\d{3,4}$/;
